import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { getStatistics, IStatisticsResponse } from "@/services/backend-service";

// Shared in-flight request so multiple consumers (e.g. the desktop and mobile
// hero both render HomeAds) trigger only a single /statistics call per load.
let statisticsPromise: Promise<IStatisticsResponse | null> | null = null;
const fetchStatistics = (): Promise<IStatisticsResponse | null> => {
  if (!statisticsPromise) {
    statisticsPromise = (async () => {
      const data = await getStatistics();

      // Don't cache failures so a later mount can retry.
      if (!data) {
        statisticsPromise = null;
      }
      return data;
    })();
  }
  return statisticsPromise;
};
export interface UseStatisticsResult {
  statistics: IStatisticsResponse | null;
  isLoading: boolean;
}
export const useStatistics = () => {
  const $ = _c(5);
  const [statistics, setStatistics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let mounted = true;
      const loadStatistics = async () => {
        const data = await fetchStatistics();
        if (!mounted) {
          return;
        }
        if (data) {
          setStatistics(data);
        }
        setIsLoading(false);
      };
      loadStatistics();
      return () => {
        mounted = false;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isLoading || $[3] !== statistics) {
    t2 = {
      statistics,
      isLoading
    };
    $[2] = isLoading;
    $[3] = statistics;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};